// src/Api/services/clientService.ts

import { GetRequestsRenseponse } from "../../Types/ProductManagement";
import api from "../axios";

import { ENDPOINTS } from "../endpoints";

export const productService = { 

  updateProductRequestStatus: (status: string, id: string, reson?: string) =>
    api.put(`${ENDPOINTS.PRODUCT_REQUESTS}/${id}`, {
      status: status,
      reson: reson,
    }),
};
